import React, { useContext, useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import MenuBar from './../components/Menubar';
import User from './../components/Utils';
import LoaderContext from './../components/LoaderContext';

type Props = {
  user: User,
  handleLogin(user: any): void
};

const AdminSuspiciousReferralPage: React.FC<Props> = (props) => {
  const [error, setError] = useState('');
  const [items, setItems] = useState<any[]>([]);
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [showJumpToTopButton, setShowJumpToTopButton] = useState(false);
  let didCancel = false;

  useEffect(() => {
    const handleScroll = () => setShowJumpToTopButton(window.scrollY > window.innerHeight);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (props.user.isLogged) loadData();
    return () => { didCancel = true; };
  }, [props.user.isLogged]);

  const handleErrors = (r: Response) => { if (!r.ok) throw Error(r.statusText || 'Error'); return r; };

  const loadData = async () => {
    showLoader();
    fetch(`${process.env.REACT_APP_SERVER_URL}/rewards/admin/suspicious-referrals?v=${Date.now()}`, {
      method: 'GET',
      headers: new Headers({ 'Content-Type': 'application/json', 'Accept': 'application/json', 'Authorization': 'Bearer ' + props.user.token }),
    })
      .then(handleErrors).then(r => r.json())
      .then((result) => { if (!didCancel) { hideLoader(); setItems(result); setError(""); } })
      .catch((err) => { if (!didCancel) { hideLoader(); setError(err.message); } });
  };

  const handleAction = async (id: number, action: 'block' | 'approve') => {
    showLoader();
    fetch(`${process.env.REACT_APP_SERVER_URL}/rewards/admin/suspicious-referrals/${id}/${action}`, {
      method: 'POST',
      headers: new Headers({ 'Content-Type': 'application/json', 'Accept': 'application/json', 'Authorization': 'Bearer ' + props.user.token }),
    })
      .then(handleErrors).then(() => loadData())
      .catch((err) => { hideLoader(); setError(err.message); });
  };

  if (!props.user.isLogged || (props.user.id !== 6 && props.user.id !== 7 && props.user.id !== 514)) {
    return <div><div>Access denied.</div></div>;
  }

  return (
    <main>
      <div className="container mypage">
        <section>
          <MenuBar user={props.user} />
          <div className="page-box-main">
            <h2 className="futuralt-book pt-2 mb-4 text-center f-22">
              <button className="next-button">Suspicious Referrals</button>
            </h2>
            {error !== '' && <p style={{ color: 'red', textAlign: 'center' }}>{error}</p>}
            <div>
              {items.length === 0 ? (
                <p>No suspicious referral activity found.</p>
              ) : (
                <div className="table-container">
                  <table className="shares-table">
                    <thead>
                      <tr>
                        <td>
                          <strong>User Name</strong>
                        </td>
                        <td>
                          <strong>Email</strong>
                        </td>
                        <td>
                          <strong>Rewards Total</strong>
                        </td>
                        <td>
                          <strong>Referrals Total</strong>
                        </td>
                        <td>
                          <strong>Referrals in 1h</strong>
                        </td>
                        <td>
                          <strong>Detected At</strong>
                        </td>
                        <td>
                          <strong>Status</strong>
                        </td>
                        <td>
                          <strong>Action</strong>
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      {items.map((item) => (
                        <tr key={item.id}>
                          <td>{item.userName}</td>
                          <td style={{ fontSize: '14px' }}>{item.email}</td>
                          <td align="center">{item.rewardsTotal}</td>
                          <td align="center">{item.referralsTotal}</td>
                          <td align="center">{item.referralsIn60Mins}</td>
                          <td style={{ fontSize: '14px' }}>{new Date(item.flaggedAt).toLocaleDateString()}</td>
                          <td style={{ fontSize: '14px' }}>{item.status}</td>
                          <td>
                            <span
                              onClick={() => handleAction(item.id, 'approve')}
                              style={{
                                marginRight: '12px',
                                cursor: 'pointer',
                                textDecoration: 'underline',
                                fontSize: '16px',
                              }}
                            >
                              Approve
                            </span>
                            <span
                              onClick={() => handleAction(item.id, 'block')}
                              style={{
                                cursor: 'pointer',
                                textDecoration: 'underline',
                                fontSize: '16px',
                                color: 'red',
                              }}
                            >
                              Block
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
              <div>
                <button className="next-button black">
                  <Link to="/admin">Back</Link>
                </button>
              </div>
            </div>
          </div>
        </section>
      </div>
      {showJumpToTopButton && (
        <button className="jump-to-top-button" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
          Jump to Top
        </button>
      )}
    </main>
  );
};

export default AdminSuspiciousReferralPage;

